export interface ParsedAddress {
  name: string;
  email: string;
}

// Parse a raw email header string ("Name <a@x.com>, b@y.com") into {name, email} pairs.
// Emails are lowercased so callers can compare them directly; names keep their original case.
export function parseAddressList(raw: string | undefined | null): ParsedAddress[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map((part) => {
      const match = part.match(/<([^>]+)>/);
      const email = (match ? match[1] : part).trim().toLowerCase();
      const name = match ? part.slice(0, match.index).replace(/["']/g, '').trim() : '';
      return { name, email };
    })
    .filter((a) => a.email.includes('@'));
}

// The first address of a header, or null when the header is empty/unparseable.
export function parseAddress(raw: string | undefined | null): ParsedAddress | null {
  return parseAddressList(raw)[0] ?? null;
}

// Display label for an address: the human name when present, the address otherwise.
// Named to avoid colliding with formatAddress in utils/addressFormat (postal addresses).
export function formatEmailAddress(a: ParsedAddress): string {
  return a.name || a.email;
}
